module.exports = __webpack_public_path__ + "img/arrow-up-circle.c3782851.svg";